import { Grid, makeStyles, Tooltip } from "@material-ui/core"
import React, { useState, useEffect, Fragment, useRef } from "react"
import { useDispatch } from "react-redux"
import { getDocumentRowClickRequest } from "../../actions/documentModalActions"
import { operationsHelper } from "../../helpers/operations"
import EmailMetadata from "./EmailMetadata"

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		border: "1px solid #dbdbdb",
		padding: "10px",
		borderRadius: "3px",
		margin: "10px 10px 10px 0px",
	},
	label: {
		textAlign: "right",
		fontWeight: "500",
		color: "#2c3533",
	},
	emailRef: {
		textDecoration: "underline",
		cursor: "pointer",
		display: "-webkit-box",
		"-webkit-line-clamp": "1",
		"-webkit-box-orient": "vertical",
		overflow: "hidden",
		textOverflow: "ellipsis",
		WebkitLineClamp: "2",
	},
	content: {
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
}))

const MetadataLayout = ({ content, item, maskHightlight }) => {
	const classes = useStyles()
	const dispatch = useDispatch()

	const handleSelectDocument = (id) => {
		dispatch(getDocumentRowClickRequest(id))
	}

	try {
		if (item !== undefined && item.hasOwnProperty("source")) {
			switch (item.source) {
				case "email":
				case "eml":
				case "msg":
					return (
						<EmailMetadata
							content={content}
							item={item}
							maskHightlight={maskHightlight}
							handleSelectDocument={handleSelectDocument}
						/>
					)
					break
				case "word":
				case "docx":
				case "doc":
				case "txt":
				case "ppt":
				case "xls":
				case "html":
				case "xml":
					return (
						<Fragment>
							<div className={classes.root}>
								<Grid container spacing={1}>
									<Grid item xs={12} sm={6} md={6} lg={6}>
										<Grid container spacing={3}>
											<Grid item xs={3} sm={3} md={3} lg={3}>
												<div className={classes.label}>Title:</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9}>
												{content?.title ? (
													<Tooltip title={`Title: ${content?.title}`}>
														<p
															dangerouslySetInnerHTML={maskHightlight(content.title, item.idItem)}
															className={classes.content}
														></p>
													</Tooltip>
												) : (
													<p>-</p>
												)}
											</Grid>
										</Grid>
									</Grid>
									{content?.parent?.doc_id && (
										<Grid item xs={12} sm={6} md={6} lg={6}>
											<Grid container spacing={3}>
												<Grid item xs={3} sm={3} md={3} lg={3}>
													<div className={classes.label}>Email ref.:</div>
												</Grid>
												<Grid item xs={9} sm={9} md={9} lg={9}>
													<Tooltip title={content?.parent?.file_name}>
														<a
															onClick={() => handleSelectDocument(content.parent.doc_id)}
															className={classes.emailRef}
														>
															{content?.parent?.file_name}
														</a>
													</Tooltip>
												</Grid>
											</Grid>
										</Grid>
									)}
								</Grid>

								<Grid container spacing={1}>
									<Grid item xs={12} sm={6} md={6} lg={6}>
										<Grid container spacing={3}>
											<Grid item xs={3} sm={3} md={3} lg={3}>
												<div className={classes.label}>Author:</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9}>
												{content.author ? (
													<Tooltip title={`Author: ${content?.author}`}>
														<p
															id="document_subject_div"
															dangerouslySetInnerHTML={maskHightlight(content.author, item.idItem)}
															className={classes.content}
														></p>
													</Tooltip>
												) : (
													<p>-</p>
												)}
											</Grid>
										</Grid>
									</Grid>

									<Grid item xs={12} sm={6} md={6} lg={6}>
										<Grid container spacing={3}>
											<Grid item xs={3} sm={3} md={3} lg={3}>
												<div className={classes.label}>Page:</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9}>
												{content?.page_number ? (
													<p>
														{content.page_number} of {content.total_page_number}
													</p>
												) : (
													<p>-</p>
												)}
											</Grid>
										</Grid>
									</Grid>
								</Grid>

								<Grid container spacing={1}>
									<Grid item xs={12} sm={6} md={6} lg={6}>
										<Grid container spacing={3}>
											<Grid item xs={3} sm={3} md={3} lg={3}>
												<div className={classes.label}>File path:</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9}>
												{content?.filepath ? (
													<Tooltip title={`File Path: ${content?.filepath}`}>
														<p
															id="document_from_div"
															dangerouslySetInnerHTML={maskHightlight(content.filepath, item.idItem)}
															className={classes.content}
														></p>
													</Tooltip>
												) : (
													<p>-</p>
												)}
											</Grid>
										</Grid>
									</Grid>

									{/* <Grid item xs={12} sm={6} md={6} lg={6}>
                                <Grid container spacing={3}>
                                    <Grid item xs={3} sm={3} md={3} lg={3} >
                                        <div className={classes.label}>
                                            Page:
                                        </div>
                                    </Grid>
                                    <Grid item xs={9} sm={9} md={9} lg={9}>
                                       <p> {content.page_number} of {content.total_page_number}</p>
                                    </Grid>
                                </Grid>
                            </Grid> */}
								</Grid>

								<div style={{ display: content.category !== undefined && content.category !== "" ? "block" : "none" }}>
									<strong>Category:</strong>
									<p
										id="document_subject_div"
										dangerouslySetInnerHTML={maskHightlight(content.category, item.idItem)}
									></p>
								</div>

								<div
									style={{
										display: content.content_status !== undefined && content.content_status !== "" ? "block" : "none",
									}}
								>
									<strong>Content status:</strong>
									<p
										id="document_subject_div"
										dangerouslySetInnerHTML={maskHightlight(content.content_status, item.idItem)}
									></p>
								</div>

								<div style={{ display: content.identifier !== undefined && content.identifier !== "" ? "block" : "none" }}>
									<strong>Identifier:</strong>
									<p
										id="document_subject_div"
										dangerouslySetInnerHTML={maskHightlight(content.identifier, item.idItem)}
									></p>
								</div>

								<div style={{ display: content.keywords !== undefined && content.keywords !== "" ? "block" : "none" }}>
									<strong>Keywords:</strong>
									<p
										id="document_subject_div"
										dangerouslySetInnerHTML={maskHightlight(content.keywords, item.idItem)}
									></p>
								</div>

								<div style={{ display: content.language !== undefined && content.language !== "" ? "block" : "none" }}>
									<strong>Language:</strong>
									<p
										id="document_subject_div"
										dangerouslySetInnerHTML={maskHightlight(content.language, item.idItem)}
									></p>
								</div>

								<div style={{ display: content.version !== undefined && content.version !== "" ? "block" : "none" }}>
									<strong>Version:</strong>
									<p id="document_subject_div" dangerouslySetInnerHTML={maskHightlight(content.version, item.idItem)}></p>
								</div>
							</div>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "10px" }}>
									<strong>Content: </strong>
								</Grid>
							</Grid>
						</Fragment>
					)

					break
				case "pdf":
					return (
						<Fragment>
							<div className={classes.root}>
								<Grid container spacing={1}>
									<Grid item xs={12} sm={6} md={6} lg={6}>
										<Grid container spacing={3}>
											<Grid item xs={3} sm={3} md={3} lg={3}>
												<div
													className={classes.label}
													// style={{textAlign: content?.parent?.doc_id ? "right" : "left"}}
												>
													Title:
												</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9}>
												{content?.title ? (
													<Tooltip title={`Title: ${content?.title}`}>
														<p
															dangerouslySetInnerHTML={maskHightlight(content.title, item.idItem)}
															className={classes.content}
														></p>
													</Tooltip>
												) : (
													<p>-</p>
												)}
											</Grid>
										</Grid>
									</Grid>
									{content?.parent?.doc_id && (
										<Grid item xs={12} sm={6} md={6} lg={6}>
											<Grid container spacing={3}>
												<Grid item xs={3} sm={3} md={3} lg={3}>
													<div className={classes.label}>Email ref.:</div>
												</Grid>
												<Grid item xs={9} sm={9} md={9} lg={9}>
													<Tooltip title={content?.parent?.file_name}>
														<a
															onClick={() => handleSelectDocument(content?.parent?.doc_id)}
															className={classes.emailRef}
														>
															{content?.parent?.file_name}
														</a>
													</Tooltip>
												</Grid>
											</Grid>
										</Grid>
									)}
								</Grid>

								<Grid container spacing={1}>
									<Grid item xs={12} sm={6} md={6} lg={6}>
										<Grid container spacing={3}>
											<Grid item xs={3} sm={3} md={3} lg={3}>
												<div className={classes.label}>Author:</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9}>
												{content.author ? (
													<Tooltip title={`Author: ${content?.author}`}>
														<p
															id="document_subject_div"
															dangerouslySetInnerHTML={maskHightlight(content.author, item.idItem)}
															className={classes.content}
														></p>
													</Tooltip>
												) : (
													<p>-</p>
												)}
											</Grid>
										</Grid>
									</Grid>

									<Grid item xs={12} sm={6} md={6} lg={6}>
										<Grid container spacing={3}>
											<Grid item xs={3} sm={3} md={3} lg={3}>
												<div className={classes.label}>Page:</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9}>
												{content?.page_number ? (
													<p>
														{" "}
														{content.page_number} of {content.total_page_number}
													</p>
												) : (
													<p>-</p>
												)}
											</Grid>
										</Grid>
									</Grid>
								</Grid>

								<Grid container spacing={1}>
									<Grid item xs={12} sm={6} md={6} lg={6}>
										<Grid container spacing={3}>
											<Grid item xs={3} sm={3} md={3} lg={3}>
												<div className={classes.label}>File path:</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9}>
												{content?.filepath ? (
													<Tooltip title={`File Path: ${content?.filepath}`}>
														<p
															id="document_from_div"
															dangerouslySetInnerHTML={maskHightlight(content.filepath, item.idItem)}
															className={classes.content}
														></p>
													</Tooltip>
												) : (
													<p>-</p>
												)}
											</Grid>
										</Grid>
									</Grid>

									{/* <Grid item xs={12} sm={6} md={6} lg={6}>
                                <Grid container spacing={3}>
                                    <Grid item xs={3} sm={3} md={3} lg={3} >
                                        <div className={classes.label}>
                                            Page:
                                        </div>
                                    </Grid>
                                    <Grid item xs={9} sm={9} md={9} lg={9}>
                                       <p> {content.page_number} of {content.total_page_number}</p>
                                    </Grid>
                                </Grid>
                            </Grid> */}
								</Grid>
							</div>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "10px" }}>
									<strong>Content: </strong>
								</Grid>
							</Grid>
						</Fragment>
					)

					break
				default:
					return ""
			}
		} else {
			return <Fragment></Fragment>
		}
	} catch (e) {
		return <Fragment></Fragment>
	}
}

export default MetadataLayout
